import React, {useCallback, useState} from "react";
import {Button, Form, FormControl, InputGroup, Modal, Table} from "react-bootstrap";
import {csrfHeader} from "./lib/utils";
import isEmpty from "lodash/isEmpty";
import debounce from "lodash/debounce";
const controller = new AbortController();

export const RemoteIslandsForm = ({url, q, entries, master}) => {
    console.log({master});
    const isMaster = JSON.parse(master);
    const [query, setQuery] = useState(q || '');
    const [address, setAddress] = useState(q || '');
    const [addressError, setAddressError] = useState('');
    const [showDialog, setShowDialog] = useState(false);
    const [addresses, setAddresses] = useState((entries && JSON.parse(entries)) || [])
    const onQueryChange = e => {
        setQuery(e.target.value);
        setAddress(e.target.value);
        search(e.target.value);
    };
    const search = useCallback(debounce(async (q) => {
        controller.abort();
        window.history.replaceState({}, null, `${location.pathname}?q=${q}`);
        const res = await fetch(`${url}.json?q=${q}`, {headers: {...csrfHeader()}});
        const addresses = await res.json();
        setAddresses(addresses);
    }, 500), []);
    const onShowDialog = e => {
        e.preventDefault();

        setShowDialog(true);

        return false;
    }
    const handleDialogClose = () => setShowDialog(false);
    const onAddAddress = () => {
        fetch(url, {method: 'POST', body: JSON.stringify({address}), headers: {'Content-Type': 'application/json', ...csrfHeader()}})
            .then(onAddressAdd)
            .catch(e => console.error(e));
    };
    const onAddressAdd = async e => {
        if (e.status === 400) {
            const {errors} = await e.json();
            if (errors) {
                setAddressError(errors.address.join(', '));
            }
        } else {
            setAddressError('');
            location.reload();
        }
    };
    const onDelete = async address => {
        if (!confirm(`${address.address}を削除しますか?`)) {
            return;
        }
        await fetch(`${url}/${address.id}`, {method: 'DELETE', headers: csrfHeader()});
        location.reload();
    };
    return <>
        <Form>
            <FormControl placeholder="住所を検索"
                         onChange={onQueryChange}
                         value={query}
            />
        </Form>
        {
            isMaster && !isEmpty(query) && <div className="mt-2 ml-2 text-underline">
                <a href='#' onClick={onShowDialog}>住所「{query}」を離島設定に追加</a>
            </div>
        }
        <Modal
            show={showDialog}
            onHide={handleDialogClose}
            backdrop="static"
            keyboard={false}
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title>離島設定を追加</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <FormControl value={address} onChange={e => setAddress(e.target.value)} />
                <span className="text-danger mt-2 ml-2 text-sm">{addressError}</span>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleDialogClose}>
                    キャンセル
                </Button>
                <Button variant="primary" onClick={onAddAddress}>追加</Button>
            </Modal.Footer>
        </Modal>
        <Table striped className="mt-4">
            <tbody>
            {
                addresses.map((address, i) => <tr key={`address-${i}`}>
                    <td>{address.id}</td>
                    <td>{address.address}</td>
                    <td>{address.created_at}</td>
                    <td>{
                        isMaster && address.deletable && <button className="btn btn-danger" onClick={() => onDelete(address)}>削除</button>
                    }</td>
                </tr>)
            }
            </tbody>
        </Table>
    </>;
};